import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core'
import { DecimalPipe } from '@angular/common'

import { SessionService } from '../services/session/session.service'
import { get, merge } from 'lodash';

@Pipe({
    name: 'number',
    standalone: false
})
export class NumberPipe implements PipeTransform {
  private pipe

  private separators = {
    'comma': ',',
    'period': '.',
    'space': ' '
  }
  private separator: string

  constructor(@Inject(LOCALE_ID) locale: string, session: SessionService) {
    this.pipe = new DecimalPipe(locale)
    const separatorName = <string> get(session, 'account.options.separator') || 'space'
    this.separator = this.separators[separatorName]
  }

  transform(value: number, options = {}): string {
    if (value == null) {
      return 'n/a'
    }

    const opts = merge({
      digits: '1.0-0'
    }, options)

    const transformed = this.pipe.transform(value, opts['digits'])
    return transformed.replace(/,/g, this.separator)
  }
}
